module.exports = __webpack_public_path__ + "static/map-bb49a330c6ce716424d81a5b2584cd0e.png";